import { Component } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ReactiveFormsModule } from '@angular/forms';

@Component({
  selector: 'app-form-radio-validation',
  styleUrls: ['form-radioValidation.component.scss'],
  template: `
    @if (props.label) {
      <!-- eslint-disable-next-line @angular-eslint/template/label-has-associated-control -->
      <label
        class="section w-100"
        tabindex="0"
        [class.mat-error]="formControl.errors"
        [innerHTML]="props.label"
      >
        @if (props.required) {
          <sup>*</sup>
        }
      </label>
    }
    @if (props.help) {
      <span
        matTooltip="{{ props.help }}"
        aria-label="help"
        tabindex="0"
        [matTooltipPosition]="'above'"
        [matTooltipClass]="'rb-tooltip'"
      >
        <mat-icon class="col-1 help-icon"> help </mat-icon>
      </span>
    }
    @if (props.prompt) {
      <p
        class="explanation"
        tabindex="0"
        [class.mat-error]="formControl.errors"
        [innerHTML]="props.prompt"
      ></p>
    }
    @if (props.placeholder) {
      <p
        class="italic"
        tabindex="0"
        [class.mat-error]="formControl.errors"
        [innerHTML]="props.placeholder"
      ></p>
    }

    <mat-radio-group
      class="radio-group radio-group-validate col-12"
      [formControl]="formControl"
      [formlyAttributes]="field"
      [required]="props.required"
      (change)="props.change ? to.change(field, formControl) : ''"
    >
      @for (opt of to?.options; track $index) {
        <mat-radio-button
          id="{{ field.key }}-{{ $index }}"
          class="radio-button"
          [value]="opt.value"
        >
          @switch (opt.value.toString()) {
            @case ('0') {
              <mat-icon>highlight_off</mat-icon>
            }
            @case ('1') {
              <mat-icon>stars</mat-icon>
            }
            @case ('2') {
              <mat-icon>find_in_page</mat-icon>
            }
            @case ('RET') {
              <mat-icon>beach_access</mat-icon>
            }
            @case ('CF') {
              <mat-icon>school</mat-icon>
            }
            @case ('OTH') {
              <mat-icon>multiline_chart</mat-icon>
            }
            @case ('LI') {
              <mat-icon>security</mat-icon>
            }
          }
          {{ opt.label }}
        </mat-radio-button>
      }
      @if (
        formControl.hasError('required') && !formControl.hasError('regRequired')
      ) {
        <mat-error>This field is required</mat-error>
      }
      @if (formControl.hasError('regRequired')) {
        <mat-error>
          This field is needed for suitability review. You can opt out below if
          the applicant refuses to provide the information.
        </mat-error>
      }
    </mat-radio-group>
  `,
  imports: [
    FormlyModule,
    MatIconModule,
    MatRadioModule,
    MatInputModule,
    MatTooltipModule,
    ReactiveFormsModule,
  ],
})
export class FormlyRadioValidationComponent extends FieldType {}
